/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Uploadcsv2Inputs */

const en_coinvestments_error_uploadcsv2 = /** @type {(inputs: Coinvestments_Error_Uploadcsv2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to upload CSV file`)
};

/**
* | output |
* | --- |
* | "Failed to upload CSV file" |
*
* @param {Coinvestments_Error_Uploadcsv2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_uploadcsv2 = /** @type {((inputs?: Coinvestments_Error_Uploadcsv2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Uploadcsv2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_uploadcsv2(inputs)
});
export { coinvestments_error_uploadcsv2 as "coInvestments_error_uploadCsv" }